<template>
  <div class="row mb-5 b-contracts__component-item-inner b-form__container_type_flex b-form__row_type_flex-end">
    <div class="col-2" :class="{'col-4': isPopup}">
      <div>
        <label>{{$t('CONTENT.sum')}} ({{currencyCode}}):</label>
        <numeric class="b-numeric" controls :max="1000000000000" v-model="sum"></numeric>
      </div>
    </div>
    <div class="col-2" :class="{'col-4': isPopup}">
      <div>
        <label>{{$t('CONTENT.date')}}:</label>
        <datepicker class="b-datepicker" v-model="startDate" :formatter="datepickerFormat"></datepicker>
      </div>
    </div>
    <button type="button" class="b-btn b-btn_border_none" @click="deleteDevaluationsItem(devaluationsItemIndex)">
      <dynamic-icon class="b-btn__icon" icon="close"></dynamic-icon>
    </button>
  </div>
</template>

<script>
	import dateConverter from "../../../utils/converters/date.converter";
	import { mapGetters } from "vuex";
  import datepickerFormat from '@/mixins/datepickerFormat.mixin';

  export default {
		props: {
      devaluationsItem: {
        type: Object,
      },
      devaluationsItemIndex: {
        type: Number,
      },
      assetComponent: {
        type: Object,
      },
      isPopup: {
        type: Boolean
      }
    },
    mixins: [datepickerFormat],
    computed: {
      ...mapGetters(["getContractSettings"]),
      currencyCode() {
        return this.getContractSettings.currencyCode;
      },
      sum: {
        get() {
          if (this.devaluationsItem.sum !== null) {
            return this.devaluationsItem.sum;
          }
        },
        set(newVal) {
          this.devaluationsItem.sum = newVal;

          this.$store.commit("assetComponentsPlugin/updateAssetComponentDevaluation", {
            devaluationsItem: this.devaluationsItem,
            assetComponent: this.assetComponent,
          });
        }
      },
      startDate: {
        get() {
          if (this.devaluationsItem.startDate === null) {
            return null;
          } else {
            return dateConverter.convertToDate(this.devaluationsItem.startDate);
          }
        },
        set(newVal) {
          if(newVal !== null) {
            this.devaluationsItem.startDate = dateConverter.convertToString(newVal);
          } else {
            this.devaluationsItem.startDate = null;
          }

          this.$store.commit("assetComponentsPlugin/updateAssetComponentDevaluation", {
            devaluationsItem: this.devaluationsItem,
            assetComponent: this.assetComponent,
          });
        }
      },
    },
    methods: {
      deleteDevaluationsItem(itemIndex) {
        this.$emit('onDeleteDevaulation', itemIndex, this.devaluationsItem);
      }
    }
	}
</script>
